export interface Chunk {
  index: number;
  rows: GridChunkRowMetadata[];
  loaded?: boolean;
  loading?: boolean;
  loadingIndicator?: boolean;
}

export interface ColumnData {
  columnId: string;
  columnName: string;
  columnDescription?: string;
  sortable?: boolean;
  widthPx?: number;
  minContentWidth?: boolean;
}

export interface ComputedGridModel {
  columnsData: ColumnData[];
  subRows: BaseGridChunkSubRowMetadata[];
  loading: boolean;
  viewId: string;
  totalRows: number;
}

export interface GridChunkModel {
  rows: GridChunkRow[];
}

export interface GridChunkRow {
  rowId: string;
  subRows: GridChunkSubRow[];
}

export interface GridChunkSubRow {
  subRowData: Record<string, any>;
}

export interface GridChunkRowMetadata {
  chunkIndex?: number;
  rowId: string;
  rowIndex: number;
  rowIndexInChunk: number;
  loading?: boolean;
  displayedSubRows: BaseGridChunkSubRowMetadata[];
  fullSubRows: GridChunkSubRow[];
}

export interface BaseGridChunkSubRowMetadata extends GridChunkSubRow {
  index: number;
  subRowId: string;
  subRowIndex: number;
  rowId: string;
  rowIndex: number;
  rowIndexInChunk: number;
  subRowType: SubRowType;
  loading: boolean;
  chunkIndex?: number;
}

export enum SubRowType {
  Data = 'data',
  ExpandCollapse = 'showMore',
}

export interface DataSubRow extends BaseGridChunkSubRowMetadata {
  rowData: Record<string, string>; // TODO: To rename to "cells"
}

export interface ExpandCollapseRow extends BaseGridChunkSubRowMetadata {
  displayedChunksCount?: number;
  hiddenChunksCount?: number;
}
